import React from 'react'
import { connect } from 'react-redux';
import { numberAddCommas } from 'servos/formValidations'
import GreyBig from './GreyBig'

const assetRow = ({ amount, provider }) => (
  <div className='row'>
    <div className='col-6 col-md-4'>
      { provider }
    </div>
    <div className='col-6 col-md-4 text-right'>
      ${ numberAddCommas(amount) }
    </div>
  </div>
)

class Asset extends React.Component {

  renderAsset = () => {
    const { review } = this.props
    return review.assets.map((asset, index) => (
      <GreyBig
        size='4'
        grey={asset.typeLabel}
        big={ assetRow(asset) }
        key={index}
      />
    ))
  }

  render() {
    const { } = this.props
    return (
      <div className='card card-single'>
        <div className='card-header'>
          <div className='pull-right'>
            <a className='smaller' href='#' onClick={ () => this.props.onGoToClick('assets')}>Edit</a>
          </div>
          Assets
        </div>
        <div className='card-body'>
          {this.renderAsset()}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  review: state.review,
})

export default connect(mapStateToProps, {
})(Asset)
